import { FormGroup } from '@angular/forms';

export class VisualizationDialogData {
  FromGroupForVisualization: FormGroup;
}
